import useLogger from "../hooks/useLogger.js";
const fetchConfig = (getToken) => async ({
  configURI
}) => {
  const logger = useLogger("fetchConfig");
  const accessToken = getToken?.();
  if (!accessToken) {
    logger.error("Access token is undefined");
    throw null;
  }
  try {
    if (!configURI) {
      logger.error("config URI is undefined");
      throw null;
    }
    const response = await fetch(configURI, {
      method: "GET",
      headers: {
        Authorization: `${accessToken}`
      }
    });
    const config = await response.text();
    return config;
  } catch (error) {
    logger.error("Error fetching data:", error);
    throw null;
  }
};
export {
  fetchConfig as default
};
